
document.querySelectorAll(".product_section > dt").forEach(function(dt) {
    dt.addEventListener("click", function(event) {
        var section = dt.closest(".product_section");

        if (section.classList.contains("open")) {
            section.classList.remove("open");
            section.querySelectorAll("dd").forEach(function(dd) {
                dd.style.display = "none";
            });
            return;
        }

        // Close other open sections
        document.querySelectorAll(".product_section dd").forEach(function(dd) {
            dd.style.display = "none";
        });
        document.querySelectorAll(".product_section").forEach(function(sec) {
            sec.classList.remove("open");
        });

        // Open the clicked section
        section.classList.add("open");
        section.querySelectorAll("dd").forEach(function(dd) {
            dd.style.display = "block";

        });

       // adjustAllVideoHeights();

        setTimeout(function () {
            var finalScrollTarget = section.getBoundingClientRect().top + window.scrollY - 175;
            window.scrollTo({ top: finalScrollTarget, behavior: "smooth" });
        }, 50);
    });
});



jQuery(document).ready(function () {


    $("#submenu_products a").click(function (e) {
        e.preventDefault();
        var this_link = $(this).data("link");
        var $targetAccordion = $("#" + this_link);

        if ($targetAccordion.length) {
            var $dt = $targetAccordion.find("dt");

            // Open the accordion only if it's not already open
            if (!$targetAccordion.hasClass("open")) {
                $(".product_section dd").slideUp(); // Close all
                $(".product_section").removeClass("open");
                console.log($targetAccordion.offset().top);

                $targetAccordion.addClass("open").find("dd").slideDown(300, function () {
                    //adjustAllVideoHeights();
                    setTimeout(function () {
                        var finalScrollTarget = $targetAccordion.offset().top - 175;
                        window.scrollTo({ top: finalScrollTarget, behavior: "smooth" });
                    }, 50);
                });
            }
        }
    });

    $("#product_accessories .accessory").click(function (e) {
        e.preventDefault();
        var link = $(this).data("link");
        if (link) {
            window.open(link, "_blank");
        }
    });



});